// import { useMemo } from "react";
// import { useQuery } from "urql";
// import dummyData from "../objs/_SameObjs/UserList/DummyData.json";
// // import { UserGroupQry } from "api/queries";
// export const useUserGroup = (pause = false) => {
//   //   const [{ data }] = useQuery({
//   //     query: userGroupQry,
//   //     context: useMemo(() => ({ requestPolicy: "cache-first" }), []),
//   //     pause,
//   //   });
//   const { groupListObj } = dummyData || {};
//   return groupListObj.groups;
// };

type GroupOption = {
  value: string;
  label: string;
};

// TODO: implement useUserGroup
export const useUserGroup = (): GroupOption[] | null => {
  return null;
};
